module.exports = "/resources/assets/prod/7eb9078c76d033696cd1127b6f2c0448.jpg";